import { useCallback, useState } from "react";

const useTheme = () => {
    const [themeState] = useState('gridTheme');

    const [optionsTheme] = useState({
        defaultTheme: {
            
        },
    })

    const loadTheme = useCallback(
        () => {
            const { defaultTheme } = optionsTheme;
            switch (themeState) {
                default:
                    return defaultTheme;
            }
        }, [optionsTheme, themeState]
    )

    const currentTheme = loadTheme();

    return {
        loadTheme, currentTheme, optionsTheme
    }
}

export default useTheme;
